<template>
  <v-overlay :absolute="absolute" class="align-center justify-center layering">
    <v-card :light="!this.$vuetify.theme.dark" class="pa-4">
      <v-card-title class="text-h5 ma-4">
        {{ $t("components.DialogVT.contactVT") }}
      </v-card-title>
      <v-card-text class="ma-4">{{ $t("components.DialogVT.desc") }}</v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
export default {
  name: "DialogVT",
  props: {
    contained: Boolean,
  },
  data: function () {
    return {};
  },
  computed: {
    absolute: function () {
      return this.contained;
    },
  },
};
</script>
<style lang="scss" scoped></style>
